
// src/web/components/stamp-palette.jsx

import React from 'react'
import connect from '../../connects/stamp-palette'
import classnames from 'classnames'
import { translate } from 'react-i18next'
import { PropTypes } from 'prop-types'
import _ from 'lodash'
import {
  Dialog,
} from 'react-toolbox/lib/dialog'
import {
  Layout,
  Panel,
} from 'react-toolbox/lib/layout'
import {
  Button,
} from 'react-toolbox/lib/button'
import {
  Tab,
  Tabs
} from 'react-toolbox/lib/tabs'
import ScrollableDialogPanel from './scrollable-dialog-panel.jsx'
import stamps from '../../config/stamps'
import '../styles/stamps.scss'
import theme from './themes/action-dialog.css'
import userAgent from './user-agent'
import StampTheme from './themes/stamp-palette.css'

const GAMBA_KEY = 'gamba'
const HANKO_KEY = 'hanko'
const ANIMAL_KEY = 'animal'

const GAMBA_STAMP = _.filter(stamps, (stamp)=> stamp.category == GAMBA_KEY)
const HANKO_STAMP = _.filter(stamps, (stamp)=> stamp.category == HANKO_KEY)
const ANIMAL_STAMP = _.filter(stamps, (stamp)=> stamp.category == ANIMAL_KEY)

class Stamp extends React.Component {
  onSelect = (event)=> {
    if(typeof this.props.ui.code == 'undefined'){
      this.props.onSelect(event.currentTarget.attributes['data-code'].value, this.props)
    }else{
      if(this.props.ui.code == event.currentTarget.attributes['data-code'].value) {
        this.props.onSend(this.props)
      }else{
        this.props.ui.code != event.currentTarget.attributes['data-code'].value && this.props.onSelect(event.currentTarget.attributes['data-code'].value, this.props)
      }
    }
  }
  render() {
    const {
      onSend,
      onSelect,
      stampPalette,
      ui,
    } = this.props
    return (
      <ScrollableDialogPanel extraHeight={52}>
        {_.map(stampPalette, (stamp)=> 
          <div key={stamp.code} className={ ui.code && stamp.code == ui.code && StampTheme.selected || StampTheme.nomal } >
            <span key={stamp.code}
                  data-code={stamp.code}
                  onClick={this.props.ui.active && this.onSelect}
                  style={{ cursor: 'pointer', opacity: ui.code && stamp.code != ui.code && 0.3 || undefined }}
                  className={classnames('stamp', stamp.code)} />
          </div>
        )}
      </ScrollableDialogPanel>  
    )
  }
}

class StampPaletteProvider extends React.Component {
  state = {}
  changeTab = (tabIndex) => {
    this.props.changeStampTab()
    this.props.updateUI({ tabIndex })
  }

  render() {
    const {
      t,
      ui,
      children,
      updateUI,
      onClose,
      onSelect,
      onSend,
      changeStampTab,
      showStampPalette,
    } = this.props

    const actions = [
      { label: t('label:送信'), onClick: ()=>onSend(this.props), disabled: (ui.requiredConfirm && ui.code) ? false : true, raised: true, primary: true },
      { label: t('label:取り消し'), onClick: ()=>onClose(this.props), raised: true },
    ]

    return (
      <div className={userAgent() == 'ie' ? 'no-svg' : 'svg'}>
        <Dialog active={ui.active} theme={theme}
            className={userAgent() == 'ie' ? 'no-svg' : 'svg'}
            actions={ui.requiredConfirm && actions || [actions[1]]}
            onOverlayClick={()=> onClose(this.props)}
            onEscKeyDown={()=> onClose(this.props)} >
          <Tabs fixed index={ui.tabIndex} onChange={this.changeTab}>
            <Tab ripple={false} className={classnames(StampTheme.gambaIcon, StampTheme.label)} activeClassName={classnames(StampTheme.activeGambaIcon, StampTheme.label)}>
              <Stamp ui={this.props.ui} stampPalette={GAMBA_STAMP} onSelect={onSelect} onSend={onSend}/>
            </Tab>
            <Tab ripple={false} className={classnames(StampTheme.hankoIcon, StampTheme.label)} activeClassName={classnames(StampTheme.activeHankoIcon, StampTheme.label)}>
              <Stamp ui={this.props.ui} stampPalette={HANKO_STAMP} onSelect={onSelect} onSend={onSend}/>
            </Tab>
            <Tab ripple={false} className={classnames(StampTheme.animalIcon, StampTheme.label)} activeClassName={classnames(StampTheme.activeAnimalIcon, StampTheme.label)}>
              <Stamp ui={this.props.ui} stampPalette={ANIMAL_STAMP} onSelect={onSelect} onSend={onSend}/>
            </Tab>
          </Tabs>
        </Dialog>
        {children}
      </div>
    )
  }
}

export default connect(StampPaletteProvider)



// WEBPACK FOOTER //
// ./src/web/components/stamp-palette.jsx